import { Box, Typography } from "@material-ui/core";
import { Grid, styled } from "@mui/material";
import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { imagesList, StateOptions } from "../../constants";
import { primary } from "../../constants/theme";
import { MemoizedButton } from "../../SDK/button";
import { MemoizedNameField } from "../../SDK/input/nameInput";
import { MemoizedPhoneField } from "../../SDK/input/phoneInput";
import { MemoizedSelectDropDown } from "../../SDK/selectDropdown/selectDropdown";
import { checkError } from "../../SDK/utils/validationHelpers";
import { createCookieInHour } from "../../utils/cookie";
import { myScroll } from "../../utils/myScroll";
import useBookingFormReferal from "./Hook/useReferalBookingForm";
import ReferralConfirmation from "./referralSuccess";

const CustomBookingForm = styled(Box)(({ theme }) => ({
  ".check-label": {
    width: "100%",
    maxWidth: "500px",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#666666",
  },
  ".referal-input": {
    maxWidth: "500px",
    width: "100%",
    marginBottom: "24px",
  },
  ".form-head": {
    fontWeight: "500",
    fontSize: "23.7372px",
    lineHeight: "49px",
    letterSpacing: "-0.02em",
    color: primary.mainText,
  },
  ".terms-and-conditions": {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "18px",
    textAlign: "center",
    marginTop: "10px",
    maxWidth: "500px",
    color: primary.main,
    textDecoration: "underline",
    cursor: "pointer",
  },
  ".title": {
    fontSize: "32px",
    margin: "0px 0px",
  },
  ".form-info": {
    padding: "0px 16px 0px 16px",
  },
  [theme.breakpoints.down("md")]: {
    //marginTop: "24px",
    //padding: "16px",
    ".title": {
      fontSize: "20px",
    },
    ".check-label": {
      fontSize: "14px",
      lineHeight: "20px",
    },
    ".form-head": {
      fontSize: "16px",
      lineHeight: "24px",
    },
    ".image-refer-and-earn": {
      width: "100%",
    },
    ".terms-and-conditions": {
      fontSize: "10px",
      lineHeight: "15px",
    },
    ".form-info": {
      padding: "0px 16px 0px 16px",
    },
  },
}));

const ReferralBookingForm = () => {
  const [isChecked, setIsChecked] = useState(true);
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const { form, loading, showSuccess } = useBookingFormReferal();

  return (
    <CustomBookingForm>
      {showSuccess ? (
        <ReferralConfirmation />
      ) : (
        <Grid container spacing={2}>
          <Grid sx={{ display: "block" }} item xs={12} md={6}>
            <LazyLoadImage
              src={imagesList.referalBanner}
              alt="Refer and earn-Turno"
              effect="opacity"
              className="image-refer-and-earn"
              width="100%"
            />
          </Grid>
          <Grid sx={{ display: "block" }} item xs={12} md={6}>
            <Box className="form-info">
              <h1 className="title" style={{ color: primary.mainText }}>
                Refer and get{" "}
                <strong style={{ color: primary.main }}>
                  upto ₹5000 cashback
                </strong>
              </h1>

              <form onSubmit={form.handleSubmit} className="form-booking">
                <Typography className="form-head">{"Your Details"}</Typography>
                <MemoizedNameField
                  sx={{ marginRight: { xs: "0px", md: "10px" } }}
                  className="input-box referal-input"
                  name="name"
                  placeholder="Your Name"
                  value={form.values.name}
                  onChange={(e) => {
                    form.handleChange(e);
                  }}
                />
                <MemoizedPhoneField
                  error={!!checkError("mobile", form)}
                  helperText={form.errors.mobile}
                  className="input-box referal-input"
                  name="mobile"
                  placeholder="Your Mobile"
                  value={form.values.mobile}
                  onChange={(e) => {
                    form.handleChange(e);
                  }}
                />
                <Typography className="form-head">
                  {"Friends Number"}
                </Typography>
                <MemoizedPhoneField
                  error={!!checkError("referalNumber", form)}
                  helperText={form.errors.referalNumber}
                  className="input-box referal-input"
                  name="referalNumber"
                  placeholder="Your Friends Number"
                  value={form.values.referalNumber}
                  onChange={(e) => {
                    form.handleChange(e);
                  }}
                />
                <MemoizedSelectDropDown
                  className="input-box referal-input"
                  form={form}
                  id={"state"}
                  name="state"
                  required={true}
                  title={"Select state"}
                  value={form.values.state}
                  optionsData={StateOptions}
                  onChange={form.handleChange}
                  error={!!checkError("state", form)}
                  // helperText={form.errors.state}
                />
                <Box
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "baseline",
                  }}
                  sx={{ mt: { xs: "24px", md: "24px" } }}
                >
                  <input
                    label="bookingForm-checkbox"
                    type="checkbox"
                    required={true}
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <Typography className="check-label">
                    I agree to the terms and conditions below and give my
                    consent to receive calls and messages to provide further
                    information, even if my number is registered on DND/NDNC.
                  </Typography>
                </Box>
                <MemoizedButton
                  id="lead-form"
                  content={"Submit Referral"}
                  loading={loading}
                  disabled={!isChecked}
                  handleClick={() => {
                    createCookieInHour("lead_trigger", "referral_form", 10);
                    form.handleSubmit();
                  }}
                  sx={{
                    width: "100%",
                    mt: "24px",
                    maxWidth: "500px",
                  }}
                />
              </form>
              <Typography
                className="terms-and-conditions"
                onClick={() => {
                  myScroll(
                    0,
                    document.getElementById("footer").offsetTop - 100,
                    "smooth"
                  );
                  // window?.scrollTo &&
                  //   window?.scrollTo({
                  //     top: document.getElementById("footer").offsetTop - 100,
                  //     behavior: "smooth",
                  //   });
                }}
              >
                Terms and Conditions
              </Typography>
            </Box>
          </Grid>
        </Grid>
      )}
    </CustomBookingForm>
  );
};
// export default ReferralBookingForm;
export const MemoizedReferralBookingForm = React.memo(ReferralBookingForm);
